/**
 * Test reordering sections on the homepage: * https:www.notion.so/faire/Low-lift-testing-Batch-4-91865b68cf0244c4a00ca000d196a71e?pvs=4
 */
export const HOMEPAGE_REORDERING_092724 = 'HOMEPAGE_REORDERING_092724';
